import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mutate-entity-modal-body" }
const _hoisted_2 = { class: "checkbox-wrapper" }
const _hoisted_3 = { for: "already-invoiced" }
const _hoisted_4 = {
  key: 0,
  class: "loading apollo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormItem = _resolveComponent("FormItem")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onClose: _ctx.closeModal,
    class: "add-expense"
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("titles.expenses.add")), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"])),
          id: "mutateFrom"
        }, [
          _createVNode(_component_FormItem, {
            input: _ctx.name,
            "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
            errors: _ctx.v$.name.$errors,
            label: _ctx.t(`labels.expenses.name`),
            name: "expense-name"
          }, null, 8, ["input", "errors", "label"]),
          _createVNode(_component_FormItem, {
            input: _ctx.formatPrice(_ctx.costNet),
            "onUpdate:input": _cache[1] || (_cache[1] = (val) => (_ctx.costNet = _ctx.parsePriceToCents(val))),
            errors: _ctx.v$.costNet.$errors,
            label: _ctx.t(`labels.expenses.costNet`),
            name: "expense-cost"
          }, null, 8, ["input", "errors", "label"]),
          _createVNode(_component_FormItem, {
            input: _ctx.formatPrice(_ctx.costGross),
            "onUpdate:input": _cache[2] || (_cache[2] = (val) => (_ctx.costGross = _ctx.parsePriceToCents(val))),
            errors: _ctx.v$.costGross.$errors,
            label: _ctx.t(`labels.expenses.costGross`),
            name: "expense-cost"
          }, null, 8, ["input", "errors", "label"]),
          _createVNode(_component_FormItem, {
            input: _ctx.quantity,
            "onUpdate:input": [
              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.quantity) = $event)),
              _cache[4] || (_cache[4] = (val) => (_ctx.quantity = parseInt(val)))
            ],
            errors: _ctx.v$.quantity.$errors,
            label: _ctx.t(`labels.expenses.quantity`),
            name: "expense-quantity"
          }, null, 8, ["input", "errors", "label"]),
          _createVNode(_component_FormItem, {
            input: _ctx.date,
            "onUpdate:input": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.date) = $event)),
            errors: _ctx.v$.date.$errors,
            label: _ctx.t(`labels.expenses.date`),
            "input-type": "date",
            name: "expense-date"
          }, null, 8, ["input", "errors", "label"]),
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "already-invoiced",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.alreadyInvoiced) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.alreadyInvoiced]
            ]),
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.t('labels.expenses.alreadyInvoiced')), 1)
          ])
        ], 32)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.t("loading")), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_BasicButton, {
        type: "submit",
        form: "mutateFrom",
        value: _ctx.t('buttons.expenses.add'),
        disabled: _ctx.loading,
        class: "add-expense-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("buttons.expenses.add")), 1)
        ]),
        _: 1
      }, 8, ["value", "disabled"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}